// extracted by mini-css-extract-plugin
export default {"slickNext":"NextArrow_slickNext__gM-sf"};